export default "__VITE_ASSET__CezRxBOs__"